import List from './actions/list';
import Find from './actions/find';
import Create from './actions/create';
import Update from './actions/update';
import Delete from './actions/delete';
import Resource from './resource';

export default class ClassificationSet extends Resource {
  get resourceName() {
    return 'classification_set';
  }

  get resourcesName() {
    return 'classification_sets';
  }
}
// @ts-ignore
List.includeInto(ClassificationSet);
// @ts-ignore
Find.includeInto(ClassificationSet);
// @ts-ignore
Create.includeInto(ClassificationSet);
// @ts-ignore
Update.includeInto(ClassificationSet);
// @ts-ignore
Delete.includeInto(ClassificationSet);
